import React, { useCallback, useState } from "react";
import Navbar from "@/components/Navbar";
import MarketStrip from "@/components/MarketStrip";
import Hero from "@/components/Hero";
import SwapWidget from "@/components/SwapWidget";
import SidePanel from "@/components/SidePanel";
import PriceChart from "@/components/PriceChart";
import MarketsTable from "@/components/MarketsTable";
import Networks from "@/components/Networks";
import Features from "@/components/Features";
import Footer from "@/components/Footer";

export default function Landing() {
  const [quoteCtx, setQuoteCtx] = useState(null);
  const [historyVersion, setHistoryVersion] = useState(0);
  const [selectedRouteIndex, setSelectedRouteIndex] = useState(0);
  const [chartSymbol, setChartSymbol] = useState("ETH");
  const [routes, setRoutes] = useState([]);

  const onQuoteChange = useCallback((ctx) => {
    setQuoteCtx(ctx);
    if (ctx?.routes) setRoutes(ctx.routes);
  }, []);
  const onHistoryChange = useCallback(() => setHistoryVersion((v) => v + 1), []);
  const onFromTokenChange = useCallback((t) => t?.symbol && setChartSymbol(t.symbol), []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <MarketStrip />
      <main className="max-w-[1440px] mx-auto px-3 sm:px-5 lg:px-8 pb-8">
        <Hero />
        <section id="swap" className="grid grid-cols-1 lg:grid-cols-[460px_1fr] gap-3 sm:gap-4 pt-2">
          <div className="min-w-0">
            <SwapWidget
              onQuoteChange={onQuoteChange}
              onHistoryChange={onHistoryChange}
              selectedRouteIndex={selectedRouteIndex}
              onFromTokenChange={onFromTokenChange}
            />
          </div>
          <div id="activity" className="min-w-0 space-y-3 sm:space-y-4">
            <PriceChart symbol={chartSymbol} />
            <SidePanel
              quoteCtx={quoteCtx}
              routes={routes}
              historyVersion={historyVersion}
              selectedRouteIndex={selectedRouteIndex}
              onSelectRoute={setSelectedRouteIndex}
            />
          </div>
        </section>
        <MarketsTable />
        <Networks />
        <Features />
      </main>
      <Footer />
    </div>
  );
}
